module.exports = __webpack_public_path__ + "static/img/tabela.b0e5916.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/citrus/tabela.png
// module id = 33TV
// module chunks = 0